import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const key = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !key) {
  throw new Error(
    'Missing VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY. Copy classroom/.env.example ' +
    'to classroom/.env and fill it from the repo-root .env.',
  );
}

/**
 * ── DELIBERATELY NOT A COPY OF app/supabase.ts ──────────────────────────────
 *
 * Three of that file's choices are wrong in a browser and one of them is the
 * long comment it carries:
 *
 *   storage           the app hands auth-js an expo-secure-store adapter.
 *                     SecureStore does not exist here; the default localStorage
 *                     store is the correct one and is what auth-js picks on its
 *                     own.
 *
 *   lock              the app must pass `processLock` because React Native has
 *                     no `navigator.locks` and auth-js silently falls back to a
 *                     no-op, racing its own token refresh and signing people
 *                     out. A browser HAS `navigator.locks`, so auth-js picks up
 *                     a real lock for free. Passing processLock here would
 *                     REPLACE that with a weaker in-process one.
 *
 *   detectSessionInUrl  false on the phone, which uses a deep link. It must be
 *                     true here: email confirmation and password reset both
 *                     come back as a URL fragment that only this flag consumes.
 */
export const supabase = createClient(url, key, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'implicit',
  },
});
